import { MAP_PAGE_ZONES } from './mapUtils'
import { PAGE_NAME, FEATURE_TILE_TRACKING_ZONE, BANNER_PAGE_ZONES, SEO_PAGE_ZONE } from './constants'

const BASE_SCHEMA = {
  type: 'object',
  properties: {
    category: {
      type: 'string',
      enum: ['Home Page', PAGE_NAME],
    },
    eventDetail: {
      type: 'string',
      pattern: '^(?!.*undefined)/[^;]*;/[^;]*;[^;]*;[^;]*$',
    },
  },
  required: ['category', 'label', 'eventDetail', 'navigationDetail'],
  additionalProperties: false,
}

export const FEATURE_TILE_SCHEMA = {
  ...BASE_SCHEMA,
  properties: {
    ...BASE_SCHEMA.properties,
    label: {
      type: 'string',
      pattern: `^(?!.*undefined)Content:(?:${FEATURE_TILE_TRACKING_ZONE}|[^_]+_[^_]+_Row[1-9][0-9]*)$`,
    },
    navigationDetail: {
      type: 'string',
      pattern: '^(?!.*undefined).+:([0-9][0-9]*)$',
    },
  },
  additionalProperties: true,
}

export const CATEGORIES_SCHEMA = {
  ...BASE_SCHEMA,
  properties: {
    ...BASE_SCHEMA.properties,
    label: {
      type: 'string',
      pattern: '^(?!.*undefined)Content:(Hero|Category Section|[^_]+_[^_]+_Row[1-9][0-9]*)$',
    },
    navigationDetail: {
      type: 'string',
      pattern: '^(?!.*undefined).*$',
    },
  },
  additionalProperties: true,
}

export const BANNER_SCHEMA = {
  ...BASE_SCHEMA,
  properties: {
    ...BASE_SCHEMA.properties,
    label: {
      type: 'string',
      pattern: `^(?!.*undefined)Content:(${Object.values(BANNER_PAGE_ZONES).join('|')})$`,
    },
    navigationDetail: {
      type: 'string',
      //The banner does not always have a position so we just check that it's defined and does not contain 'undefined'
      pattern: '^(?!.*undefined).+$',
    },
  },
}

export const BANNER_MAP_SCHEMA = {
  type: 'object',
  properties: {
    label: {
      type: 'string',
      pattern: `^(?!.*undefined)MAP tracking homepage (${Object.values(MAP_PAGE_ZONES).join('|')}) (click|view)$`,
    },
    experimentName: {
      type: 'string',
      pattern: `^(?!.*undefined)MAP_tracking_(${Object.values(MAP_PAGE_ZONES).join('|')})$`,
    },
    variationName: { type: 'string', format: 'uuid' },
    experimentDetail: { type: 'string', format: 'uuid' },
    impressionEventVersion: { type: 'integer', const: 3 },
  },
  required: ['label', 'experimentName', 'variationName', 'experimentDetail', 'impressionEventVersion'],
  additionalProperties: false,
}

export const SLIM_BANNER_SCHEMA = {
  ...BASE_SCHEMA,
  properties: {
    ...BASE_SCHEMA.properties,
    label: {
      type: 'string',
      pattern: '^(?!.*undefined)Content:Slim Banner Section$',
    },
    navigationDetail: {
      type: 'string',
      pattern: '^(?!.*undefined).*$',
    },
  },
}

export const SEO_ZONE_SCHEMA = {
  ...BASE_SCHEMA,
  properties: {
    ...BASE_SCHEMA.properties,
    label: {
      type: 'string',
      pattern: `^(?!.*undefined)Content:${SEO_PAGE_ZONE}$`,
    },
    navigationDetail: {
      type: 'string',
      pattern: '^(?!.*undefined)[^:]+:[1-9][0-9]*$',
    },
  },
}

export const NEXT_BEST_ACTION_SCHEMA = {
  ...BASE_SCHEMA,
  properties: {
    ...BASE_SCHEMA.properties,
    label: {
      type: 'string',
      pattern: '^(?!.*undefined)Content:Next Best Action Panel$',
    },
    navigationDetail: {
      type: 'string',
      pattern: '^(?!.*undefined).+:[1-9][0-9]*$',
    },
  },
  additionalProperties: true,
}
